var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{ref:"markmap",staticClass:"flex-1",class:{dark : _vm.$theme.darkTheme},attrs:{"id":"mind-map"}})}
var staticRenderFns = []

export { render, staticRenderFns }